<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        data() {
            return {
                isAuthorized: false,
                list: []
            }
        },
        mounted() {
            if(this.adminOnly()) {
                this.list = [
                    {
                        title: 'Карточка',
                        url: `/restaurants/${this.$route.params.id}`
                    },
                    {
                        title: 'Редактировать',
                        url: `/restaurants/${this.$route.params.id}/edit`
                    },
                    {
                        title: 'Описание',
                        url: `/restaurants/${this.$route.params.id}/description`
                    },
                    {
                        title: 'Дополнительное описание',
                        url: `/restaurants/${this.$route.params.id}/additional-description`
                    },
                    {
                        title: 'Меню',
                        url: `/restaurants/${this.$route.params.id}/dishes`
                    },
                    {
                        title: 'Категории',
                        url: `/restaurants/${this.$route.params.id}/categories`
                    },
                    {
                        title: 'Ингредиенты',
                        url: `/restaurants/${this.$route.params.id}/ingredients`
                    },
                    {
                        title: 'Модификаторы',
                        url: `/restaurants/${this.$route.params.id}/modifiers`
                    },
                    {
                        title: 'Импорт',
                        url: `/restaurants/${this.$route.params.id}/import`
                    },
                    {
                        title: 'Акции',
                        url: `/restaurants/${this.$route.params.id}/promotions`
                    },
                    {
                        title: 'Словарь',
                        url: `/restaurants/${this.$route.params.id}/dictionary`
                    },
                    {
                        title: 'Доставка',
                        url: `/restaurants/${this.$route.params.id}/delivery`
                    },
                    {
                        title: 'Перенаправление доставки',
                        url: `/restaurants/${this.$route.params.id}/delivery-address-redirect`
                    },
                    {
                        title: 'Настройки по башням',
                        url: `/restaurants/${this.$route.params.id}/tower-settings`
                    },
                    {
                        title: 'Платное ожидание',
                        url: `/restaurants/${this.$route.params.id}/waiting-price`
                    },
                    {
                        title: 'Реклама',
                        url: `/restaurants/${this.$route.params.id}/aplace`
                    },
                    {
                        title: 'Настройки',
                        url: `/restaurants/${this.$route.params.id}/settings`
                    },
                    {
                        title: 'Стол заказов',
                        url: `/restaurants/${this.$route.params.id}/shop-catalog`
                    },
                ]
            } else {
                this.list = [
                    {
                        title: 'Карточка',
                        url: `/restaurants/${this.$route.params.id}`
                    },
                    {
                        title: 'Редактировать',
                        url: `/restaurants/${this.$route.params.id}/edit`
                    },
                    {
                        title: 'Описание',
                        url: `/restaurants/${this.$route.params.id}/description`
                    },
                    {
                        title: 'Меню',
                        url: `/restaurants/${this.$route.params.id}/dishes`
                    },
                    {
                        title: 'Категории',
                        url: `/restaurants/${this.$route.params.id}/categories`
                    },
                    {
                        title: 'Ингредиенты',
                        url: `/restaurants/${this.$route.params.id}/ingredients`
                    },
                    {
                        title: 'Модификаторы',
                        url: `/restaurants/${this.$route.params.id}/modifiers`
                    }
                ]
            }
        },
        methods: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        }
    }
</script>
